// extracted by mini-css-extract-plugin
export default {"reportGridContainer":"ReportGrid_reportGridContainer__N1t1N","reportGrid":"ReportGrid_reportGrid__7vFBN"};